import React, { useEffect } from "react";
import { connect } from "react-redux";
import "./Loader.css";
import Lottie from "react-lottie";
import loading_anim from "../../animations/Knovo_Loading.json";
function Loader(props) {
  const [progress, setProgress] = React.useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const loadingAnime = {
    loop: true,
    autoplay: true,
    animationData: loading_anim,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  function renderOnBoardingAnime1() {
    return (
      <Lottie
        options={loadingAnime}
        speed={1}
        isStopped={false}
        style={{
          width: "200px",
          height: "200px",
          justifyContent: "center",
          alignSelf: "center",
          objectFit: "contain",
        }}
      />
    );
  }

  return <div className="loader-container">{renderOnBoardingAnime1()}</div>;
}
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Loader);
